var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyWorkspaceIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 18",
    width: 25,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MyWorkspaceIconActive-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: none;stroke: #8f92b9;stroke-opacity: .5 } \n\t\t.s2 { opacity: .6;fill: #ffffff } \n\t\t.s3 { opacity: .5;fill: #ffffff } \n\t\t.s4 { fill: none;stroke: #b74935;stroke-linecap: round;stroke-width: 1.5 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m4 6.2c0-1.1 0.9-2 2-2h15.4c1.1 0 2 0.9 2 2v9.8c0 1.1-0.9 2-2 2h-15.4c-1.1 0-2-0.9-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m4 6.2c0-1.1 0.9-2 2-2h15.4c1.1 0 2 0.9 2 2v9.8c0 1.1-0.9 2-2 2h-15.4c-1.1 0-2-0.9-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m20.1 0.8c0.3-0.4 1-0.5 1.4-0.2l3.4 2.1c0.4 0.3 0.6 1 0.3 1.4l-3.3 5.1c-0.3 0.4-1 0.5-1.4 0.2l-3.4-2.1c-0.4-0.4-0.6-1-0.3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m21.7 2.8c0.4-0.3 1.1-0.2 1.4 0.2l2.3 3.3c0.3 0.4 0.2 1.1-0.2 1.4l-4.9 3.5c-0.4 0.3-1.1 0.2-1.4-0.2l-2.3-3.3c-0.3-0.4-0.2-1.1 0.2-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m2.4 2.7c-0.1-0.5 0.3-1 0.8-1.1l4-0.6c0.5-0.1 1 0.3 1.1 0.8l0.9 5.9c0.1 0.6-0.2 1.1-0.8 1.2l-3.9 0.6c-0.6 0.1-1.1-0.3-1.2-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m0.4 9.7c-0.4-0.3-0.6-0.9-0.3-1.4l2.1-3.4c0.3-0.5 0.9-0.6 1.4-0.3l5.1 3.1c0.5 0.3 0.6 0.9 0.3 1.4l-2.1 3.4c-0.3 0.5-0.9 0.6-1.4 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m9.7 4.4v-1.4c0-1.1 0.9-2 2-2h4.1c1.1 0 2 0.9 2 2v1.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWorkspaceIconActive);
export default __webpack_public_path__ + "static/media/MyWorkspaceIconActive.de74f723bdf1eb1ed62217a5902c1188.svg";
export { ForwardRef as ReactComponent };